import React from "react";
import ComponentTitle from "./ComponentTitle";
import GridForm from "./GridForm";

const QualityInput = ({cellRefs, inputData, setInputData, stagingStatus,selectedData, setSelectedData, enter}) => {
  return (
    <div>
      <div className="py-1 border-b border-gray-400 flex">
        <ComponentTitle title={"☞ 표준 환경 조건"}/>
        <div className="font-bold px-3">온도: 23±1ºC, 습도: 50±2% RH, 조습 시간: 2Hr</div>
      </div>
      <div>
        <GridForm cellRefs={cellRefs} enter={enter} inputData={inputData} setInputData={setInputData} stagingStatus={stagingStatus} selectedData={selectedData} setSelectedData={setSelectedData} />
      </div>
    </div>
  )
}

export default QualityInput